// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Oswald', 'Oswald Fallback'","fontStyle":"normal"},"className":"__className_2c607e","variable":"__variable_2c607e"};